/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaChartLine } from 'react-icons/fa';
export var GetAccountLiquidity = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'GETTER',
    method: 'getAccountLiquidity',
    description: 'Get account liquidity that represents the USD value borrowable by a user, before it reaches liquidation',
    supportedContracts: [
        { chainId: 1, address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B' },
    ],
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'comptroller' }),
            methodParams: {
                account: new FctAddress({ isPreview: true, icon: FaChartLine }),
            },
        },
        output: {
            liquidity: new FctValue({ innerIndex: 1, destination: 'wei_amount', isPreview: true }),
            shortfall: new FctValue({ innerIndex: 2, isPreview: true }),
        },
    }); },
});
